import { Component, Input, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { CardModule } from 'primeng/card';
import { ProgressBarModule } from 'primeng/progressbar';
import { ReactionsComponent } from '../reactions/reactions.component';
import { Router } from '@angular/router';
import { CampanhaService } from '../api/services/campanha.service';
import { AnexoFicheiroService } from '../api/services/anexo-ficheiro.service';
import { MessageService } from 'primeng/api';
import { UserService } from '@app/auth/services/user.service';
import { UtilizadoresService } from '../api/services/utilizadores.service';
import { AuthService } from '@app/auth/services/auth.service';
import { AuthRedirectService } from '@app/auth/services/auth-redirect.service';

@Component({
  selector: 'app-card-destack-campanha',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ProgressBarModule,
    ReactionsComponent,
  ],
  providers: [
    CampanhaService,
    AnexoFicheiroService,
    UserService,
    UtilizadoresService,

    AuthService,
  ],
  templateUrl: './card-destack-campanha.component.html',
  styleUrl: './card-destack-campanha.component.scss',
})
export class CardDestackCampanhaComponent implements OnInit {
  @Input() campanhas: any;
  private readonly route = inject(Router);
  private readonly CampanhaService = inject(CampanhaService);
  private readonly anexoFicheiroService = inject(AnexoFicheiroService);
  private readonly messageService = inject(MessageService);
  private readonly utilizadoresService = inject(UtilizadoresService);
  private readonly userService = inject(UserService);

  private readonly authService = inject(AuthService);
  private readonly authRedirectService = inject(AuthRedirectService);
  private readonly sanitizer = inject(DomSanitizer);

  imgInfo?: { nome: string; tamanho: string; tipo: string };
  imgPreview?: string;
  campanha: any;
  IsprofileComplet: boolean = false;
  IsAuthenticad: boolean = false;

  ngOnInit(): void {
    // Carregar as campanhas e suas imagens
    this.campanhas.forEach((campanhaWrapper: any) => {
      const campanha = campanhaWrapper?.campanha;
      const campanhaID = campanha?.id;

      this.CampanhaService.show(campanhaID.toString()).subscribe({
        next: (res) => {
          const campanhaDetalhada = res.data;

          const fotoAnexo = campanhaDetalhada.anexoCampanha?.find(
            (a: any) => a?.tipoAnexoCampanha?.tipo === 'Imagem',
          );

          if (fotoAnexo?.anexo?.id) {
            this.anexoFicheiroService.getAnexo(fotoAnexo.anexo.id).subscribe({
              next: (fotoRes: any) => {
                const blob =
                  fotoRes instanceof Blob ? fotoRes : new Blob([fotoRes]);
                const imgUrl = URL.createObjectURL(blob);

                // Adiciona a imagem diretamente na campanha correspondente
                campanhaWrapper.imgPreview =
                  this.sanitizer.bypassSecurityTrustUrl(imgUrl);
              },
              error: (err) => console.error('Erro ao carregar imagem:', err),
            });
          }
        },
        error: (err) => console.error('Erro ao buscar campanha:', err),
      });
    });
    this.checkProfileUSer();
    this.authService.isAuthenticatedChange().subscribe((isAuth) => {
      this.IsAuthenticad = isAuth;
    });
  }

  getPercent(campanha: any): number {
    if (!campanha?.metaArrecadar) return 0;
    return Math.round((campanha.valorArrecado / campanha.metaArrecadar) * 100);
  }

  formatShortNum(val?: number): string {
    if (!val && val !== 0) return '0 Kz';
    if (val >= 1000000) {
      const m = val / 1000000;
      return (
        m.toLocaleString('pt-AO', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        }) + ' M Kz'
      );
    }
    if (val >= 1000) {
      const k = val / 1000;
      return (
        k.toLocaleString('pt-AO', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        }) + ' mil Kz'
      );
    }
    return val.toLocaleString('pt-AO') + ' Kz';
  }

  getCategoryIcon(descricao?: string): string {
    if (!descricao) return 'fas fa-tag';
    const d = descricao.toLowerCase();
    if (d.includes('aliment') || d.includes('comida') || d.includes('fome'))
      return 'fas fa-utensils';
    if (d.includes('saúde') || d.includes('saude') || d.includes('medic'))
      return 'fas fa-heartbeat';
    if (d.includes('educa') || d.includes('escola') || d.includes('ensino'))
      return 'fas fa-graduation-cap';
    if (
      d.includes('tecno') ||
      d.includes('digit') ||
      d.includes('app') ||
      d.includes('inova')
    )
      return 'fas fa-laptop-code';
    if (d.includes('agri') || d.includes('campo') || d.includes('rural'))
      return 'fas fa-seedling';
    if (d.includes('arte') || d.includes('cultur')) return 'fas fa-palette';
    if (d.includes('ambien') || d.includes('ecolog') || d.includes('clima'))
      return 'fas fa-leaf';
    if (
      d.includes('emerg') ||
      d.includes('social') ||
      d.includes('solidar') ||
      d.includes('habita')
    )
      return 'fas fa-home';
    if (
      d.includes('start') ||
      d.includes('negóc') ||
      d.includes('negoc') ||
      d.includes('empree')
    )
      return 'fas fa-lightbulb';
    return 'fas fa-tag';
  }

  getPctClass(pct: number): string {
    if (pct >= 70) return 'high';
    if (pct >= 30) return 'mid';
    return 'low';
  }

  getTipoFinanciamentoLabel(tipo: any): string {
    if (!tipo) return 'Doação';
    if (typeof tipo === 'string') return tipo;
    switch (Number(tipo)) {
      case 1:
        return 'Doação';
      case 2:
        return 'Empréstimo';
      case 3:
        return 'Recompensa';
      default:
        return 'Doação';
    }
  }

  getTipoFinanciamentoIcon(tipo: any): string {
    const val = typeof tipo === 'string' ? tipo.toLowerCase() : Number(tipo);
    if (val === 2 || val === 'empréstimo' || val === 'emprestimo') {
      return 'fas fa-hand-holding-dollar';
    }
    if (val === 3 || val === 'recompensa') {
      return 'fas fa-gift';
    }
    return 'fas fa-hand-holding-heart';
  }

  getDaysClass(dias: number): string {
    if (dias <= 10) return 'urgent';
    if (dias <= 30) return 'warning';
    return 'normal';
  }

  callRouteDetalheCampanha(id: number, titulo?: string) {
    if (id) {
      this.route.navigate(['/detalhe-campanha/', id]);
    }
  }

  checkProfileUSer() {
    this.utilizadoresService
      .checkPerfilUser(this.userService.getUserId() || '')
      .subscribe({
        next: (res: any) => {
          if (res?.retorno.codigo === 200) {
            this.IsprofileComplet = res?.data;
          } else {
            this.IsprofileComplet = false;
            return;
          }
        },
      });
  }

  callRouteFinacy(id: string, titulo: string, event: Event) {
    event.stopPropagation();
    if (!this.IsAuthenticad) {
      const returnUrl = '/financiar-campanha/' + id;
      this.authRedirectService.redirectToRegister(returnUrl);
      return;
    }

    if (this.IsprofileComplet) {
      this.route.navigate(['/financiar-campanha/', id]);
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Perfil incompleto',
        detail: 'Complete os dados da sua conta no seu perfil para continuar.',
        life: 8000,
      });
      this.route.navigate(['/perfil']);
    }
  }

  openRegister(returnUrl?: string): void {
    this.authRedirectService.redirectToRegister(returnUrl);
  }

  openLogin(returnUrl?: string): void {
    this.authRedirectService.redirectToLogin(returnUrl);
  }

  onCommentAdded(camp: any): void {
    if (camp?.id) {
      this.CampanhaService.show(camp.id.toString()).subscribe({
        next: (res) => {
          if (res?.data) {
            camp.totalComentarios = res.data.totalComentarios;
            if (res.data.comentarios) {
              camp.comentarios = res.data.comentarios;
            }
          }
        },
      });
    }
  }
}
